import React from 'react';
import { Navigate } from "react-router-dom";
import './Login.scss';

import useTitle from '../useTitle';

const Login = ( props ) => {

    useTitle( "Login | Kalihackz" );

	const [ isAuth, setIsAuth ] = React.useState( false );

    const [ formData, setFormData ] = React.useState(
        {
            email: "",
            pass : ""
        }
    );

    function handleChange( event ){

        const { name, type, value, checked } = event.target;

		props.onLoad(70);

        setFormData( (prevFormData) => {

            return {
                ...prevFormData,
                [name]: type === 'checkbox' ? checked : value
            };

        } );

		props.onLoad(100);

    }

    function handleSubmit( event ){

        event.preventDefault();
        
        fetch( 'https://api.subrataghosh.repl.co/api/v1/login', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'multipart/form-data'
            },
            body: JSON.stringify( formData )
          } 
        )
        .then( ( resp ) => resp.json() )
        .then( function( data ) {
            
            if ( data.success === 'true' ) {
                props.setLoginSession( 'loggedIn', 'true' );
				setIsAuth( true );
				console.log(data);
                return props.setLoginSession( data.cookieName, data.cookieValue );
            }
			alert( 'Wrong Email or Password' );
            return props.setLoginSession( 'loggedIn', 'false' );
        } )
		.catch( (e) => console.log( 'Failed to login' ) );
    
    }

	if ( isAuth ) {
	return <Navigate to='/admin' />;
	}
	return (
		<main className="main-container">
			<section></section>
			<section>
				<form onSubmit={handleSubmit}>
					<div className="login-form">
						<div className="login-form__items">
							<p> Welcome Admin !</p>
						</div>
						<div className="login-form__items">
							<input 
								className="input-text"
								type="text" 
								placeholder="Email" 
								id="email"
								name="email"
								onChange={handleChange}
								value={formData.email}
							/>
						</div>
						<div className="login-form__items">
							<input 
								className="input-text"
								type="password" 
								placeholder="Password" 
								name="pass"
								id="pass"
								onChange={handleChange}
								value={formData.pass}
							/>
						</div>
						<div className="login-form__items">
							<button className="input-btn">Submit</button>
						</div>
					</div>
				</form>
			</section>
			<section></section>
		</main>
	);
}

export default Login;


//<Navigate to='/admin' />